import React from "react";
import { Route, Routes } from "react-router-dom";

import OverNightGuestAdminPage from "~v2/pages/OvernightGuestPages/OverNightGuestAdminPage";
import OvernightGuestViewPage from "~v2/pages/OvernightGuestPages/OverNightGuestViewPage";

import DaytimeTouristAdminPage from "~v2/pages/DaytimeTouristPages/DaytimeTouristAdminPage";
import DaytimeTouristViewPage from "~v2/pages/DaytimeTouristPages/DaytimeTouristViewPage";

import InboundMonitoringAdminPage from "~v2/pages/InboundMonitoringPages/InboundMonitoringAdminPage";
import InboundMonitoringViewPage from "~v2/pages/InboundMonitoringPages/InboundMonitoringViewPage";

import TourOperatorAdminPage from "~v2/pages/TourOperatorPages/TourOperatorAdminPage";
import TourOperatorViewPage from "~v2/pages/TourOperatorPages/TourOperatorViewPage";

import MICEreportAdminPage from "~v2/pages/MICEReportPages/MICEreportAdminPage";
import MICEreportViewPage from "~v2/pages/MICEReportPages/MICEreportViewPage";

import FAQPageAdmin from "~v2/pages/FAQ-Admin/FAQAdmin";
import HomePage from "../pages/HomepageAdmin/HomepageAdmin";
import ManageReportPage from "../pages/ManageReportPage/ManageReportPage";
import InboundMonitoringAdminReportPage from "../pages/InboundMonitoringPages/InboundMonitoringAdminReportPage";
import TourOperatorAdminReportPage from "../pages/TourOperatorPages/TourOperatorAdminReportPage";
import OverNightGuestAdminReportPage from "../pages/OvernightGuestPages/OverNightGuestAdminReportPage";
import MICEAdminReportPage from "../pages/MICEReportPages/MICEAdminReportPage";
import DaytimeTouristAdminReportPage from "../pages/DaytimeTouristPages/DaytimeTouristAdminReportPage";
import ManageAccountPage from "../pages/ManageAccountPage/ManageAccountPage";
import ManageAccountPageCreate from "../pages/ManageAccountPage/ManageAccountPageCreate";
import ManageAccountPageView from "../pages/ManageAccountPage/ManageAccountPageView";
import ManageAccountPageEdit from "../pages/ManageAccountPage/ManageAccountPageEdit";
import NotificationAdmin from "../pages/NotificationAdmin/NotificationAdmin";
import NotificationAdminCreate from "../pages/NotificationAdmin/NotificationAdminCreate";
import NotificationUpdate from "../pages/NotificationAdmin/NotificationAdminEdit";
import ManageAccountPageUser from "../pages/ManageAccountPage/ManageAccountPageUser";
import ManageTREPage from "../pages/ManageTREPage/ManageTREPage";
import ManageTREPageCreate from "../pages/ManageTREPage/ManageTREPageCreate";
import ManageTREPageView from "../pages/ManageTREPage/ManageTREPageView";
import ContactsEdit from "../pages/ContactsEdit/ContactsEdit";
import Contacts from "../pages/Contacts/Contacts";
import ManageTREPageDetails from "../pages/ManageTREPage/ManageTREPageDetails";

const AdminRoutes = () => {
  return (
    <Routes>
      {/* Home Page*/}
      <Route path="/" element={<HomePage />} />

      {/* Accounts Pages*/}
      <Route path="/accounts" element={<ManageAccountPage />} />
      <Route path="/accounts/user" element={<ManageAccountPageUser />} />
      <Route
        path="/accounts/user/create"
        element={<ManageAccountPageCreate />}
      />
      <Route path="/accounts/user/view" element={<ManageAccountPageView />} />
      <Route
        path="/accounts/user/details/:id"
        element={<ManageAccountPageEdit />}
      />

      {/* Establishment Page */}
      <Route path="/accounts/tre" element={<ManageTREPage />} />
      <Route path="/accounts/tre/create" element={<ManageTREPageCreate />} />
      <Route path="/accounts/tre/edit/:id" element={<ManageTREPageCreate />} />
      <Route path="/accounts/tre/view" element={<ManageTREPageView />} />
      <Route path="/accounts/tre/details/:id" element={<ManageTREPageDetails />} />


      {/* Announcement Pages */}
      <Route path="/notification" element={<NotificationAdmin />} />
      <Route
        path="/notification/create"
        element={<NotificationAdminCreate />}
      />
      <Route path="/notification/:id" element={<NotificationUpdate />} />

      {/* Manage Report */}
      <Route path="/reports" element={<ManageReportPage />} />

      {/* Overnight Guest */}
      <Route path="overnight-guest" element={<OverNightGuestAdminPage />} />
      <Route
        path="overnight-guest/report/:establishmentId"
        element={<OverNightGuestAdminReportPage />}
      />
      <Route
        path="overnight-guest/view/:id"
        element={<OvernightGuestViewPage />}
      />

      {/* Daytime Tourist */}
      <Route path="daytime-tourist" element={<DaytimeTouristAdminPage />} />
      <Route
        path="daytime-tourist/report/:establishmentId"
        element={<DaytimeTouristAdminReportPage />}
      />
      <Route
        path="daytime-tourist/view/:id"
        element={<DaytimeTouristViewPage />}
      />

      {/* Inbound Monitoring*/}
      <Route
        path="inbound-monitoring"
        element={<InboundMonitoringAdminPage />}
      />
      <Route
        path="inbound-monitoring/report/:establishmentId"
        element={<InboundMonitoringAdminReportPage />}
      />
      <Route
        path="inbound-monitoring/view/:id"
        element={<InboundMonitoringViewPage />}
      />

      {/* Tour Operator */}
      <Route path="tour-operator" element={<TourOperatorAdminPage />} />
      <Route
        path="tour-operator/report/:establishmentId"
        element={<TourOperatorAdminReportPage />}
      />
      <Route path="tour-operator/view" element={<TourOperatorViewPage />} />
      <Route path="tour-operator/view/:id" element={<TourOperatorViewPage />} />

      {/* MICE Reports*/}
      <Route path="mice-reports" element={<MICEreportAdminPage />} />
      <Route
        path="mice-reports/report/:establishmentId"
        element={<MICEAdminReportPage />}
      />
      <Route path="mice-reports/view/:id" element={<MICEreportViewPage />} />

      {/* Other Module */}
      <Route path="faq" element={<FAQPageAdmin />} />
      <Route path="contacts" element={<Contacts />} />
      <Route path="contacts/edit" element={<ContactsEdit />} />
    </Routes>
  );
};

export default AdminRoutes;
